export default __webpack_public_path__ + "images/NR.dfdb39b.png";